import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux'
import {App} from './App';
import * as serviceWorker from './serviceWorker';
import store from "./reducers/store";

const s = document.createElement( 'link' );
s.setAttribute( 'href', '//poprawaprac.pl/wp-includes/css/dist/block-library/style.min.css?ver=5.5' );
s.setAttribute( 'rel', 'stylesheet' );
s.setAttribute( 'type', 'text/css' );
document.head.appendChild( s );ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
 